<div class="card-container">
  <mat-card class="datex-card card"
            data-cy="card" 
            [ngStyle]="styles.style" 
            [ngClass]="styles.classes">
    <ng-container
                  *ngIf="initialized && !$hasMissingRequiredInParams">



      <mat-card-title-group class="card-header">
        <div class="card-title-container">
          <ng-content></ng-content>
          <mat-card-title data-cy="card-title" class="card-title " >{{headerTitle}}</mat-card-title>
        </div>

      </mat-card-title-group>


      <mat-card-content data-cy="card-content" class="card-content" >
        <div [formGroup]="formGroupContent"
             class="formdata">
                <div data-cy="fieldset-formGroupContent-id-newGroup1"
                     *ngIf="!content.fieldsets.newGroup1.hidden && !content.fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': content.fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!content.fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="content.fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{content.fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="content.fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !content.fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': content.fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="content.fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-quantity" *ngIf="!content.fields.quantity.hidden && !content.fields.quantity.removed" 
                            class="field-container full {{content.fields.quantity.invalid ? 'invalid' : ''}} {{content.fields.quantity.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="content.fields.quantity.styles.style"
                            [ngClass]="content.fields.quantity.styles.classes">
                        <div class="label-container"
                             [matTooltip]="content.fields.quantity.label + (content.fields.quantity.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{content.fields.quantity.label}}<span *ngIf="content.fields.quantity.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="quantity"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (content.fields.quantity.control.readOnly || content.fields.quantity.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{content.fields.quantity.control.placeholder}}"
                                [ngStyle]="content.fields.quantity.control.styles.style"
                                [ngClass]="content.fields.quantity.control.styles.classes"
                                [matTooltip]="content.fields.quantity.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="content.fields.quantity.invalid">
                          <ng-container *ngFor="let error of content.fields.quantity.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-vendor_lot" *ngIf="!content.fields.vendor_lot.hidden && !content.fields.vendor_lot.removed" 
                            class="field-container standard {{content.fields.vendor_lot.invalid ? 'invalid' : ''}} {{content.fields.vendor_lot.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="content.fields.vendor_lot.styles.style"
                            [ngClass]="content.fields.vendor_lot.styles.classes">
                        <div class="label-container"
                             [matTooltip]="content.fields.vendor_lot.label + (content.fields.vendor_lot.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{content.fields.vendor_lot.label}}<span *ngIf="content.fields.vendor_lot.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="vendor_lot"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (content.fields.vendor_lot.control.readOnly || content.fields.vendor_lot.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{content.fields.vendor_lot.control.placeholder}}"
                                [ngStyle]="content.fields.vendor_lot.control.styles.style"
                                [ngClass]="content.fields.vendor_lot.control.styles.classes"
                                [matTooltip]="content.fields.vendor_lot.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="content.fields.vendor_lot.invalid">
                          <ng-container *ngFor="let error of content.fields.vendor_lot.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-lot" *ngIf="!content.fields.lot.hidden && !content.fields.lot.removed" 
                            class="field-container standard {{content.fields.lot.invalid ? 'invalid' : ''}} {{content.fields.lot.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="content.fields.lot.styles.style"
                            [ngClass]="content.fields.lot.styles.classes">
                        <div class="label-container"
                             [matTooltip]="content.fields.lot.label + (content.fields.lot.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{content.fields.lot.label}}<span *ngIf="content.fields.lot.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="lot"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (content.fields.lot.control.readOnly || content.fields.lot.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{content.fields.lot.control.placeholder}}"
                                [ngStyle]="content.fields.lot.control.styles.style"
                                [ngClass]="content.fields.lot.control.styles.classes"
                                [matTooltip]="content.fields.lot.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="content.fields.lot.invalid">
                          <ng-container *ngFor="let error of content.fields.lot.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!content.fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </mat-card-content>



    </ng-container>

    <div *ngIf="$hasMissingRequiredInParams"
        class="missing-params">
      <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
    </div>
  </mat-card>
  <div class="card-gripper"></div>
</div>